import React, { useRef, useState, useEffect, MutableRefObject } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { titleType } from "@/types/ScmEnums"
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddMaterialModal } from "./materialModel"

export const CheckDetail = () => {
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const purchaseRoDetails = useRef<IYhFormRef>();
    return <>
        <YhPageHeader title={`库存盘点${titleType[detailsInfo.mode]}`} />
        <TopButs {...detailsInfo} purchasePoDetails={purchaseRoDetails} />
        <FormBox {...detailsInfo} purchasePoDetails={purchaseRoDetails} />
        <TableBox {...detailsInfo} />
        <FixedBottom {...detailsInfo} />
        <AddMaterialModal {...detailsInfo} />
    </>
}